/**
 * @generated SignedSource<<1303008a1b53b64d2ba93e9bd49a9814>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Profile_getViewer_Query$variables = {};
export type Profile_getViewer_Query$data = {
  readonly viewer: {
    readonly email: string;
    readonly emailVerified: boolean;
    readonly id: string;
    readonly name: string;
    readonly organization: {
      readonly id: string;
      readonly name: string;
    };
    readonly preferences: {
      readonly language: string;
    };
    readonly roles: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }>;
  } | null;
};
export type Profile_getViewer_Query = {
  response: Profile_getViewer_Query$data;
  variables: Profile_getViewer_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/)
],
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emailVerified",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": (v2/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Role",
        "kind": "LinkedField",
        "name": "roles",
        "plural": true,
        "selections": (v2/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserPreferences",
        "kind": "LinkedField",
        "name": "preferences",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "Profile_getViewer_Query",
    "selections": (v3/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "Profile_getViewer_Query",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "1ea14ad1cdaea9dcc624d83e6019018b",
    "id": null,
    "metadata": {},
    "name": "Profile_getViewer_Query",
    "operationKind": "query",
    "text": "query Profile_getViewer_Query {\n  viewer {\n    id\n    name\n    email\n    emailVerified\n    organization {\n      id\n      name\n    }\n    roles {\n      id\n      name\n    }\n    preferences {\n      language\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "112c2f2a15bf2c429d516750e2e11d73";

export default node;
